// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_qAy","cls2":"Cta-cls2_32L Cta-cls1_qAy"};